module.exports = __webpack_public_path__ + "static/media/inspection_confirmation.56c1789e.svg";